export class PunchoutDataModel {
  public url: string;
  public base64Data: string; // base 64 encoded string

  constructor(url: string, base64Data: string) {
    this.url = url;
    this.base64Data = base64Data;
  }
}
